import { getKeys } from './getKeys'

export const homeChangedBlockingModalTranslations = {
  HOME_CHANGED_TITLE: 'Your home has changed',
  HOME_CHANGED_CONTINUE: 'Continue to {{homeName}}',
  HOME_CHANGED_SWITCH_BACK: 'Switch back',
  HOME_CHANGED_BODY:
    'Another tab switched your active home to <strong>{{homeName}}</strong>.'
}

export const homeChangedBlockingModalConstants = getKeys(
  homeChangedBlockingModalTranslations
)
